// extracted by mini-css-extract-plugin
module.exports = {"filter":"AccreditationFilter_filter__2xB3f","searchInput":"AccreditationFilter_searchInput__35n0r"};